import { TranslateService } from "@ngx-translate/core";
import _ from "lodash";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ValidationContext } from "~app/common/validation/validationContext";
import { IKundorderDetailKundorderrad } from "../../models/kundorder-detail-model";

export class KundorderradValidation {
    static init(
        translateService: TranslateService,
        kundorderrad: IKundorderDetailKundorderrad): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.skapa).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 1,
                message: { text: translateService.instant("TERMINALORDER_DETAIL_MOTTAGNINGSPLATS_VALIDATION") },
                model: () => kundorderrad.mottagningsplats,
                name: "mottagningsplats",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 2,
                message: { text: translateService.instant("KUNDORDER_DETAIL_HANDELSSORTIMENT_VALIDATION") },
                model: () => kundorderrad.handelssortiment,
                name: "handelssortiment",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 3,
                message: { text: translateService.instant("KUNDORDER_DETAIL_KVANTITET_VALIDATION") },
                model: () => kundorderrad.kvantitet,
                name: "kvantitet",
                expression: (value, oldVal) => !_.isNil(value) && value >= 0,
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 4,
                message: { text: translateService.instant("KUNDORDER_DETAIL_FROM_VALIDATION") },
                model: () => kundorderrad.periodFrom,
                name: "periodFrom",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (periodTom) => !!periodTom && kundorderrad.periodFrom <= periodTom,
                id: 5,
                message: { text: translateService.instant("KUNDORDER_DETAIL_TOM_VALIDATION") },
                model: () => kundorderrad.periodTom,
                name: "periodTom",
                required: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) => {
                    if(newValue) {
                        return kundorderrad.lagerplatser?.length === 1;
                    }
                    return true;
                },
                id: 6,
                message: { text: "Manuell på arbetsorder kräver att endast en avlastningsplats är vald" },
                model: () => kundorderrad.manuellPaArbetsorder,
                name: "manuellPaAo",
                subscriptions: ["lagerplats"],
                publish: true,
                verbose: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) => {
                    if(kundorderrad.manuellPaArbetsorder) {
                        return newValue?.length === 1;
                    }
                    return true;
                },
                id: 7,
                message: { text: "Om Manuell på arbetsorder skall en och endast en avlastningsplats var vald" },
                model: () => kundorderrad.lagerplatser,
                name: "lagerplats",
                subscriptions: ["manuellPaAo"],
                publish: true,
                verbose: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) => {
                    if (newValue) {
                        return kundorderrad.manuellPaArbetsorder;
                    }
                    return true;
                },
                id: 8,
                message: { text: "Egenskap X kan endast anges för rader med manuell på arbetsorder" },
                model: () => kundorderrad.egenskapskodX,
                name: "egenskapskodX",
                subscriptions: ["manuellPaAo"],
                publish: true,
                verbose: true
            }
        ]);
        return context;
    }
}
